import React, { useEffect, useRef, useState } from 'react'
import Header from "../../template/Header";
import Menu from "../../template/Menu";
import Footer from "../../template/Footer";
import Loading from "../../components/loading/Loading";
import { Button, Col, Row, Form } from "react-bootstrap";
import {
    textSearchBtn,
    textResetBtn,
    textCreateBtn,
    colorSearchBtn,
    colorResetBtn,
    colorCreateBtn,
    iconSearchBtn,
    iconResetBtn,
    iconCreateBtn,
    hoverSearchBtn,
    hoverResetBtn,
    hoverCreateBtn,
    textSaveBtn,
    textCancleBtn,
    colorSaveBtn,
    colorCancleBtn,
    hoverSaveBtn,
    hoverCancleBtn,
    colorEditBtns,
    hoverEditBtns
} from "../../components/ThemeConfig/btnConfig";
import { useButtonDynamicStyles } from "../../components/useDynamic/Button_DynamicStyle";
import { useNavigate } from 'react-router-dom';
import UploadIMG from "../../components/uploads/UploadIMG";
import { getBannerByID, updateBannerByID } from "../../api/banner_api.js";
import {
  alertValidateData,
  alertConfirmSave,
  alertSaved,
  alertCancel,
} from "../../components/alertValid/AlertValid.js"

function EditHeadBanner() {
    useButtonDynamicStyles(
        textSearchBtn,
        textResetBtn,
        textCreateBtn,
        colorSearchBtn,
        colorResetBtn,
        colorCreateBtn,
        iconSearchBtn,
        iconResetBtn,
        iconCreateBtn,
        hoverSearchBtn,
        hoverResetBtn,
        hoverCreateBtn,
        textSaveBtn,
        textCancleBtn,
        colorSaveBtn,
        colorCancleBtn,
        hoverSaveBtn,
        hoverCancleBtn,
        colorEditBtns,
        hoverEditBtns
    );
    
    const [isLoading, setLoading] = useState(false);
    const [editId, setEditId] = useState(null);
    const [images1, setImages1] = useState([]);
    const [imagesFromApi1, setImagesFromApi1] = useState([]);
    const [active, setActive] = useState(true);
    const [activeIMG, setActiveIMG] = useState(true);
    const [bannerData, setBannerData] = useState({});

    const handleSelectedImages1 = (images) => {
        setImages1(images);
    };
    const handleSelectedRemoveImg1 = (data) => {
        setImages1(data);
    };

    const navigate = useNavigate();
    const navigateToBack = (page) => {
        navigate(page);
    };

    let displayText;

    if (bannerData.banner_subcategory === "bidding") {
        displayText = "Open Tendering Project";
    } else if (bannerData.banner_subcategory === "job") {
        displayText = "Careers";
    } else if (bannerData.banner_subcategory === "aboutus") {
        displayText = "About Us";
    } else if (bannerData.banner_subcategory === "contactus") {
      displayText = "Contact Us";
    } else if (bannerData.banner_subcategory === "our_service") {
      displayText = "Our Services &  Privileges";
    } else if (bannerData.banner_subcategory === "promo") {
      displayText = "Promotions & Privileges";
    } else if (bannerData.banner_subcategory === "news") {
      displayText = "News & Event";
    }
    

    const alertValidate = async () => {
      const result = await alertValidateData();
          if (result.isConfirmed) {
              return;
          } else {
              return;
          }
  }

    const updateBannerData = async () => {
        const { _id, banner_subcategory } = bannerData;
      
        // Prepare the body for the update request
        let body = {
          banner_category: 'head_banner',
          banner_subcategory: banner_subcategory,
          format: images1.length > 0 ? 'image' : null,
          file: images1.length > 0 ? images1 : null,
          active: active === false ? 0 : 1,
        };
        
        // Validate the presence of files
        if (!body.file || body.file.length === 0) {
          await alertValidate(
            {
                title: "Please fill your information completely.",
                text: "กรุณากรอกข้อมูลให้ครบถ้วน"
            });
          return;
        }
      
        // Show confirmation dialog
        const result = await alertConfirmSave();
        if (result.isConfirmed) {
          try {
            await setLoading(true);
            const response = await updateBannerByID(_id, body);
            await setLoading(false);
            if (response.data.status === "success") {
              const res = await alertSaved();
              if (res.isConfirmed) {
                navigateToBack("/infoHeadBanner");
              }
            } else {
              // Handle failure case
              console.error("Update failed", response);
            }
          } catch (error) {
            console.error("Error updating banner", error);
          } finally {
            
          }
        }
      };
      
      const handleActiveBtn = async () => {
        await updateBannerData();
      };
      

      const handleClickCancel = async () => {
        const res = await alertCancel();
          if (res.isConfirmed) {
            navigateToBack("/infoHeadBanner");
          }
      };

    async function urlToBlob(url) {
        // Fetch the image data from the URL
        const response = await fetch(url);
    
        // Convert the fetched image data to Blob
        const blob = await response.blob();
    
        return blob;
    }

    const getDataBanner = async (id) => {
        await setLoading(true);
        try {
          const respon = await getBannerByID(id);
          const dataPreview = respon.data.data;
      
          setBannerData({
            _id: dataPreview._id,
            banner_subcategory: dataPreview.banner_subcategory,
          });
      
          setEditId(dataPreview._id);
          setActive(dataPreview.active === 1 ? true : false);
      
          if (dataPreview.format === 'image') {
            setActiveIMG(true);
            const imageBlob = await urlToBlob(dataPreview.data);
            setImagesFromApi1([{
              id: 0,
              status: false,
              src: dataPreview.data || '',
              file: imageBlob,
              size: 1024 * 1024 * 4, // hard code to pass validation
              type: 'image/jpg' // hard code to pass validation
            }]);
          }
        } catch (error) {
          console.error("Error fetching banner data", error);
        } finally {
          setLoading(false);
        }
      };
      
      useEffect(() => {
        const id = new URLSearchParams(window.location.search).get("id");
        if (id) {
          getDataBanner(id);
          setEditId(id);
        }
      }, []);

  return (
    <>
    {isLoading ? <Loading /> : ""}
        <Header parentmenu={"BANNER"} />
        <Menu
            parentmenu={"infoBanner"}
            activemenu={"infoHeadBanner"}
        />
        <div className="content-wrapper">
            <div className="container-fluid pdb-page">
                <div className="box-white">
                    <Row>
                        <Col xs={12}>
                            <font className="font-size07 colorBlack01 fontBold d-flex align-items-center">
                                <img src="assets/icons/ic-banner.png" className="ic-user01 me-2" alt="" />
                                EDIT HEAD BANNER
                            </font>
                        </Col>
                    </Row>
                    <div className='mx-5 mt-4'>
                        <Row>
                            <Col xs={12} className="mb-2">
                              <span className="font-size01 colorBlack01 fontBold">
                                {displayText}
                              </span>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                <UploadIMG
                                    limit={1}
                                    onSelectedImages={handleSelectedImages1}
                                    images={imagesFromApi1}
                                    txtDetail={"jpg. / 1920x400 px , limit size 5MB"}
                                    removeImg={handleSelectedRemoveImg1}
                                />
                            </Col>
                        </Row>
                        <Row className='mt-4'>
                            <Col xs={12} className="p-0">
                                <label className="fontLight font-size03 colorBlack01">
                                Status
                                </label>
                            </Col>
                        </Row>
                        <Form>
                            {["radio"].map((type) => (
                                <div key={`inline3-${type}`} className="mt-2 mb-3">
                                <Form.Check
                                    className="fontLight font-size03 colorBlack01 checked"
                                    inline
                                    label="Active"
                                    name="group3"
                                    type={type}
                                    id={`inline3-${type}-1`}
                                    checked={active}
                                    onChange={(e) => setActive(true)}
                                />
                                <Form.Check
                                    className="fontLight font-size03 colorBlack01"
                                    inline
                                    label="Inactive"
                                    name="group3"
                                    type={type}
                                    id={`inline3-${type}-2`}
                                    checked={!active}
                                    onChange={(e) => setActive(false)}
                                />
                                </div>
                            ))}
                        </Form>
                    </div>
                </div>
                <Row className="ms-5 mt-4">
                    <Col xs={1} className="p-0 d-flex justify-content-start me-4">
                        <button
                            className="btn-cancle01"
                            onClick={() => handleClickCancel()}
                        >
                                CANCEL
                        </button>
                    </Col>
                    <Col xs={1} className="p-0 d-flex justify-content-start">
                        <button
                            className="btn-save01"
                            onClick={(e) => {
                                handleActiveBtn(editId);
                            }}
                        >
                            SAVE
                        </button>
                    </Col>
                </Row>
            </div>
        </div>
        <Footer/>
    </>
  )
}

export default EditHeadBanner;